import {
  GET_CUSTOMER_ORDERS_REQUEST,
  GET_CUSTOMER_ORDERS_SUCCESS,
  GET_CUSTOMER_ORDERS_FAILURE,
  GET_CUSTOMER_ORDER_REQUEST,
  GET_CUSTOMER_ORDER_SUCCESS,
  GET_CUSTOMER_ORDER_FAILURE,
  CREATE_CUSTOMER_ORDER_REQUEST,
  CREATE_CUSTOMER_ORDER_SUCCESS,
  CREATE_CUSTOMER_ORDER_FAILURE,
  UPDATE_CUSTOMER_ORDER_REQUEST,
  UPDATE_CUSTOMER_ORDER_SUCCESS,
  UPDATE_CUSTOMER_ORDER_FAILURE,
  ASSIGN_GOLDSMITH_REQUEST,
  ASSIGN_GOLDSMITH_SUCCESS,
  ASSIGN_GOLDSMITH_FAILURE,
  ADD_ORDER_PAYMENT_REQUEST,
  ADD_ORDER_PAYMENT_SUCCESS,
  ADD_ORDER_PAYMENT_FAILURE,
  GET_ORDER_PAYMENTS_REQUEST,
  GET_ORDER_PAYMENTS_SUCCESS,
  GET_ORDER_PAYMENTS_FAILURE,
} from '../types';

const initialState = {
  orders: [],
  currentOrder: null,
  orderPayments: {
    payments: [],
    paymentModeTotals: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
    }
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  loading: false,
  error: null,
};

const customerOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_ORDERS_REQUEST:
    case CREATE_CUSTOMER_ORDER_REQUEST:
    case UPDATE_CUSTOMER_ORDER_REQUEST:
    case ASSIGN_GOLDSMITH_REQUEST:
    case ADD_ORDER_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_CUSTOMER_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        orders: action.payload.orders || [],
        pagination: action.payload.pagination || state.pagination,
      };

    case CREATE_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        orders: [action.payload, ...state.orders],
      };

    case UPDATE_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        orders: state.orders.map(order =>
          order.id === action.payload.id ? action.payload : order
        ),
      };

    case ASSIGN_GOLDSMITH_SUCCESS:
    case ADD_ORDER_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case GET_CUSTOMER_ORDERS_FAILURE:
    case CREATE_CUSTOMER_ORDER_FAILURE:
    case UPDATE_CUSTOMER_ORDER_FAILURE:
    case ASSIGN_GOLDSMITH_FAILURE:
    case ADD_ORDER_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_CUSTOMER_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentOrder: null,
      };

    case GET_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        currentOrder: action.payload,
      };

    case GET_CUSTOMER_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentOrder: null,
      };

    case GET_ORDER_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ORDER_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        orderPayments: {
          payments: action.payload.data.payments,
          paymentModeTotals: action.payload.data.paymentModeTotals,
          pagination: action.payload.pagination,
        },
      };

    case GET_ORDER_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default customerOrderReducer;
